/**
 * Helpers puros do modal "Autorizar e classificar" (classificação da
 * não-qualidade por item — cinco eixos: demanda, não conformidade, processo
 * de origem, causa-raiz e imputação). Sem React e sem request: só dados.
 */

export const EIXOS = ["demanda", "nao_conformidade", "processo_origem", "causa_raiz"];

/** Motivo informado pelo solicitante no item (peça usa `motivo_categoria`,
 * item de requisição usa `motivo`). */
export function motivoDoItem(item) {
  return item?.motivo_categoria || item?.motivo || "";
}

/** Linha editável a partir do item já classificado (ou vazio). */
export function linhaInicial(item) {
  return {
    item_id: item.id,
    demanda: item.demanda_codigo || "",
    nao_conformidade: item.nao_conformidade_codigo || "",
    processo_origem: item.processo_origem_codigo || "",
    causa_raiz: item.causa_raiz_codigo || "",
    imputacao: item.imputacao || "",
    responsavel_nc_nome: item.responsavel_nc_display || "",
    // Sugestão da regra do backend; só preenche a imputação enquanto a
    // pessoa não escolheu uma à mão.
    imputacao_sugerida: "",
    imputacao_manual: Boolean(item.imputacao),
  };
}

export function linhasIniciais(itens) {
  return (itens || []).map(linhaInicial);
}

/** Códigos de NC cujo `motivos_origem` contém o motivo — vêm primeiro no
 * select ("Sugeridas pelo motivo"). */
export function ncsSugeridasParaMotivo(ncs, motivo) {
  if (!motivo) return [];
  return (ncs || []).filter((nc) => (nc.motivos_origem || []).includes(motivo));
}

/** Processos sugeridos pela NC escolhida (ids) → códigos. */
export function processosSugeridosPelaNc(processos, ncs, codigoNc) {
  const nc = (ncs || []).find((n) => n.codigo === codigoNc);
  if (!nc) return [];
  const ids = new Set((nc.processos_sugeridos || []).map(String));
  return (processos || []).filter((p) => ids.has(String(p.id)));
}

/** Alguma coisa foi escolhida na linha? Linha em branco não vai no body. */
export function linhaPreenchida(l) {
  return EIXOS.some((e) => l[e]) || Boolean(l.imputacao) || Boolean(l.responsavel_nc_nome?.trim());
}

/** Body de `classificacoes` — só as linhas com algo escolhido, códigos em
 * vez de ids (o backend aceita os dois; código é legível na auditoria). */
export function montarClassificacoes(linhas) {
  return (linhas || []).filter(linhaPreenchida).map((l) => {
    const saida = { item_id: l.item_id };
    EIXOS.forEach((e) => { if (l[e]) saida[e] = l[e]; });
    if (l.imputacao) saida.imputacao = l.imputacao;
    const nome = (l.responsavel_nc_nome || "").trim();
    if (nome) saida.responsavel_nc_nome = nome;
    return saida;
  });
}

/** A configuração da unidade exige NC + processo para este tipo? */
export function precisaClassificar(cfg, tipo) {
  if (!cfg || !cfg.exige_classificacao_na_autorizacao) return false;
  return (cfg.tipos_exigem_classificacao || []).includes(tipo);
}

/** Linhas que ainda não têm NC e processo (o mínimo exigido). */
export function linhasIncompletas(linhas) {
  return (linhas || []).filter((l) => !l.nao_conformidade || !l.processo_origem);
}

/** Copia os eixos preenchidos do "aplicar a todos" para cada linha, sem
 * apagar o que a linha já tinha e o modelo deixou em branco. */
export function aplicarATodas(linhas, modelo) {
  return (linhas || []).map((l) => {
    const nova = { ...l };
    EIXOS.forEach((e) => { if (modelo[e]) nova[e] = modelo[e]; });
    if (modelo.imputacao) {
      nova.imputacao = modelo.imputacao;
      nova.imputacao_manual = true;
    }
    if (modelo.responsavel_nc_nome?.trim()) nova.responsavel_nc_nome = modelo.responsavel_nc_nome;
    return nova;
  });
}
